import React from 'react';

interface ServiceDetailsProps {
  coreServices: string[];
  compliance: {
    name: string;
    details: string;
    status: 'ACTIVE' | 'VALID' | 'BONDED' | 'CHECKED';
    icon: string;
  }[];
  isMobile?: boolean;
  isDesktop?: boolean;
}

const ServiceDetails: React.FC<ServiceDetailsProps> = ({
  coreServices,
  compliance,
  isMobile,
  isDesktop,
}) => {
  if (isMobile) {
    return (
      <section className="px-container-margin mt-stack-xl space-y-stack-lg md:hidden">
        <div>
          <h3 className="font-headline-sm text-headline-sm text-primary mb-stack-md">Core Services</h3>
          <div className="flex flex-wrap gap-2">
            {coreServices.map((service, index) => (
              <span key={index} className="bg-primary-container text-on-primary-fixed px-3 py-1.5 rounded-lg font-body-md text-body-md">
                {service}
              </span>
            ))}
          </div>
        </div>
        <div>
          <h3 className="font-headline-sm text-headline-sm text-primary mb-stack-md">Compliance &amp; Credentials</h3>
          {compliance.length === 0 ? (
            <div className="flex items-center gap-2 py-4 text-on-surface-variant text-sm">
              <span className="material-symbols-outlined text-[18px] opacity-40">verified_user</span>
              No verified credentials yet.
            </div>
          ) : (
            <div className="bg-white rounded-xl border border-outline-variant divide-y divide-outline-variant overflow-hidden">
              {compliance.map((item, index) => (
                <div key={index} className="p-4 flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <span className="material-symbols-outlined text-primary">{item.icon}</span>
                    <div>
                      <p className="font-label-bold text-label-bold text-on-surface">{item.name}</p>
                      <p className="font-label-md text-label-md text-outline">{item.details}</p>
                    </div>
                  </div>
                  <span className="material-symbols-outlined text-green-600">check_circle</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    );
  }

  if (isDesktop) {
    return (
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-gutter hidden md:grid">
        {/* Services */}
        <section className="bg-surface-container-lowest rounded-xl shadow-sm p-stack-lg border border-outline-variant space-y-stack-md">
          <h3 className="font-label-bold text-label-bold text-primary uppercase tracking-wider">Core Services</h3>
          <div className="flex flex-wrap gap-2">
            {coreServices.map((service, index) => (
              <span key={index} className="bg-surface-container px-3 py-1.5 rounded-full text-on-surface-variant font-label-md border border-outline-variant/30">
                {service}
              </span>
            ))}
          </div>
        </section>
        {/* Compliance */}
        <section className="bg-surface-container-lowest rounded-xl shadow-sm p-stack-lg border border-outline-variant space-y-stack-md">
          <h3 className="font-label-bold text-label-bold text-primary uppercase tracking-wider">Compliance &amp; Credentials</h3>
          {compliance.length === 0 ? (
            <div className="flex items-center gap-2 py-2 text-on-surface-variant text-sm">
              <span className="material-symbols-outlined text-[18px] opacity-40">verified_user</span>
              No verified credentials yet.
            </div>
          ) : (
            <div className="space-y-3">
              {compliance.map((item, index) => (
                <div key={index} className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-emerald-100">
                      <span className="material-symbols-outlined text-sm text-emerald-700">{item.icon}</span>
                    </div>
                    <span className="font-body-md">{item.name}</span>
                  </div>
                  <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-800">VERIFIED</span>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    );
  }

  return null;
};

export default ServiceDetails;